import Keycloak from "keycloak-js";
import { KeycloakIDPAdapterBuilder } from "@sia/style-guide";

const IDPUrl = process.env.REACT_APP_IDP_URL;
const realm = process.env.REACT_APP_IDP_REALM;
const clientId = process.env.REACT_APP_IDP_CLIENT_ID;

const keycloakClient = Keycloak({
  url: IDPUrl,
  realm: realm,
  clientId: clientId,
});

const KeycloakIDPAdapter = KeycloakIDPAdapterBuilder(keycloakClient, IDPUrl, realm, clientId);

export default KeycloakIDPAdapter;
